import styled, { css } from 'styled-components';

import { rem } from '../../utils';

export type CardVariant = 'filled' | 'outlined';

export const cssOutlineEffect = css<{
  variant: CardVariant;
  active?: boolean;
}>`
  ${({ theme }) => css`
    transition: box-shadow ${({ theme }) => theme.Transition.Timing.Out};

    &:hover {
      box-shadow: inset 0 0 0 ${rem(theme.Border.Size.Medium)} ${theme.Color.Brand.Primary};
      transition: box-shadow ${({ theme }) => theme.Transition.Timing.In};
    }
  `}

  ${({ variant, theme }) => {
    switch (variant) {
      case 'filled':
        return css`
          background-color: ${theme.Color.Neutrals.Light};
        `;
      case 'outlined':
        return css`
          box-shadow: inset 0 0 0 1px ${theme.Color.Neutrals.Border};
        `;
    }
  }}

  ${({ active, theme }) =>
    active &&
    css`
      box-shadow: inset 0 0 0 ${rem(theme.Border.Size.Medium)} ${theme.Color.Brand.Primary};
    `}
`;

export const CardContainer = styled.article<{
  variant: CardVariant;
  active?: boolean;
}>`
  ${cssOutlineEffect}
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
`;

export const StyledHeaderWrapper = styled.header<{
  hasChildren: boolean;
  variant: CardVariant;
}>`
  display: flex;
  flex-flow: row;
  align-items: center;
  width: 100%;
  height: 40px;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  cursor: pointer;
  user-select: none;

  ${({ theme, hasChildren, variant }) =>
    hasChildren &&
    `
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    ${variant === 'outlined' && `border-bottom: 1px ${theme.Color.Neutrals.Border} solid;`}
  `}
`;

export const StyledHeaderExtraContent = styled.div`
  margin-left: auto;
`;

export const CardBody = styled.section`
  padding: ${({ theme }) => `${rem(theme.Spacing.Size.XSmall)}`};
`;
